module.exports = __webpack_public_path__ + "img/gift-content-en.b23fb144.png";